import React from 'react';

/*
 *  @Author:        Sergio Balaguer Carmona
 *  @Description:   Stateless component that renders a Heart icon.
 */

const Heart = ( props ) => {

    return (<g id="path">
            <path
                d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
        </g>
    )

};

export default Heart;

